export function formatDateTimeToString(date, lang = 'en-US', withtime = false) {
  const realLang = localStorage.getItem('eahsLang') ?? 'en';
  const mylang = realLang == "en" ? 'en-US' : 'ar-AE'
  if(!date){
    return
  }
  if (mylang != 'en-US') {
    const dateTime = createDubaiDate(date);
    const months = ['يناير', 'فبراير', 'مارس', 'ابريل', 'مايو', 'يونيو', 'يوليو', 'اغسطس', 'سبتمبر', 'اكتوبر', 'نوفمبر', 'ديسمبر'];
    const hours = dateTime.getHours();
    const minutes = dateTime.getMinutes();
    const amOrPm = hours >= 12 ? ' م ' : ' ص ';
    const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
    if (withtime) {
      const val = `${dateTime.getDate()} ${months[dateTime.getMonth()]} ${dateTime.getFullYear()}, ${formattedHours}:${formattedMinutes}${amOrPm}`

      return val;
    } else {
      const val = `${dateTime.getDate()} ${months[dateTime.getMonth()]} ${dateTime.getFullYear()}`
      return val;
    }
  } else {
    const dateTime = createDubaiDate(date);
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const hours = dateTime.getHours();
    const minutes = dateTime.getMinutes();
    const amOrPm = hours >= 12 ? 'pm' : 'am';
    const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
    if (withtime) {
      const val = `${dateTime.getDate()} ${months[dateTime.getMonth()]} ${dateTime.getFullYear()}, ${formattedHours}:${formattedMinutes}${amOrPm}`
      return val;
    } else {
      const val = `${dateTime.getDate()} ${months[dateTime.getMonth()]} ${dateTime.getFullYear()}`
      return val;
    }
  }
}

function createDubaiDate(dateStr) {
    const dubai = new Date(dateStr);

    const parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Asia/Dubai',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
    }).formatToParts(dubai);

    const get = t => parts.find(p => p.type === t).value;

    return new Date(
        `${get('year')}-${get('month')}-${get('day')}T` +
        `${get('hour')}:${get('minute')}:${get('second')}`
    );
}
